import React, { useEffect, useState } from 'react';
// Import React FilePond
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import { FilePond, registerPlugin } from "react-filepond";

// Import the plugin code
import { Box } from '@mui/material';
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { TailSpin } from 'react-loader-spinner';
import { ADD_PAIEMENT, CHARGER_FICHIER } from '../../Utils/constant';
import { store } from '../../services/service';
import { useVerifyPaiementStore } from '../../store/verifyPaiementStore';
import { File } from '../Icons/File';
import { SubmitButton } from '../Widget/SubmitButton';
import { ValidateMessage } from '../Widget/ValidateMessage';
// Register the plugins
registerPlugin(
    FilePondPluginImageExifOrientation,
    FilePondPluginImagePreview,
    FilePondPluginImageResize
);

export const CollectePaiement = ({ handleNext, numeroTicket }) => {
    const [filesRecuPaiement, setFilesRecuPaiement] = useState([]);
    const [paiementChoix, setPaiementChoix] = useState("CASH");
    const [paiementRef, setPaiementRef] = useState(null)
    const [paiementStatus, setPaiementStatus] = useState("ATTENTE_DE_VALIDATION")
    const [loadingUpload, setLoadingUpload] = useState(false);
    const [fichierCreation, setFichierCreation] = useState("");
    const [paiementError, setPaiementError] = useState(null)
    const handleFileInput = (e) => {
        const fileUploaded = e.target.files[0];

        if (fileUploaded || fileUploaded !== undefined) {
            setFichierCreation(fileUploaded);
        }
    };

    const handleUpdateRecu = (fileItems) => {
        const newFiles = fileItems.map((fileItem) => fileItem.file);
        setFilesRecuPaiement(newFiles);
    };
    const verify = useVerifyPaiementStore()
    const isFree = useVerifyPaiementStore()

    const {
        register,
        handleSubmit, reset,
        formState: { errors },
    } = useForm()

    useEffect(() => {
        if (verify?.data?.donnee?.titre === "ATTENTE_DE_VALIDATION") {
            const interval = setInterval(() => {
                verify.verification(paiementRef)
                setPaiementStatus(verify?.data?.donnee?.titre)
            }, 2000)
            return () => clearInterval(interval);
        }

        verify?.data?.donnee?.titre === "ECHEC" ?
            setIsSubmit(false)
            : verify?.data?.donnee?.titre === "SUCCES" ?
                setIsSubmit(null)
                : setIsSubmit(false)

        if (verify?.data?.donnee?.titre === "ECHEC" && paiementRef != null) {
            setPaiementError("Votre paiement a echoué reessayer svp !")
        }

    }, [paiementRef, verify, paiementStatus])

    useEffect(() => {
        isFree.checking(numeroTicket)
    }, [])

    console.log(verify?.data?.donnee?.titre)
    const [isSubmit, setIsSubmit] = useState(false);

    const resetStates = () => {
        setPaiementRef(null);
        setPaiementError(null);
    };

    const submit = (data) => {
        setIsSubmit(true)
        const requestData = { ...data, numeroTicket: numeroTicket, recuPaiement: filesRecuPaiement[0] }
        store(ADD_PAIEMENT, 'multipart/form-data', requestData).then((res) => {
            setPaiementRef(res.data.donnee.reference)
            setPaiementStatus(res.data.donnee.titre)
            res.data.donnee.titre === 'ECHEC' ? setIsSubmit(false) : setIsSubmit(true)
            verify.verification(res.data.donnee.reference)
            if (res.status === 202) {
                res.data.donnee.titre === 'ECHEC' ? document.getElementById('failed').showModal() :
                    toast.success('Paiement en attente de validation')
            }
        }).catch((err) => {
            console.log(err);
            setIsSubmit(false)
            toast.error("Oops! une erreur s'est produite")
        })
    }

    return (
        <>
            <div className="w-full flex flex-col  mt-6">
                {
                    isFree?.isloading && isFree?.isFree === null ?
                        <div className='w-full my-4 flex items-center justify-center'>
                            <TailSpin
                                height="40"
                                width="40"
                                color="#000"
                                ariaLabel="tail-spin-loading"
                                radius="2"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={isFree?.isloading}
                            />
                        </div>
                        :
                        <>

                            {
                                verify?.data?.donnee?.titre === "SUCCES" && paiementRef != null ? (
                                    paiementChoix === 'MOMO' ?
                                        <div className='mt-3 w-full'>
                                            <div className="mt-3 mx-auto w-full lg:w-10/12 bg-white rounded-lg p-3 border border-[#f2f5fa] shadow-sm">
                                                <button
                                                    disabled={loadingUpload}
                                                    className="w-full mx-auto h-36 bg-stone-50 border border-dashed rounded-lg flex items-center justify-center cursor-pointer"
                                                    onClick={() => document.getElementById("file-zone").click()}
                                                >
                                                    <div className="flex flex-col items-center text-gray-400">
                                                        <File />
                                                        {fichierCreation ? (
                                                            <div className="mt-2 w-full flex flex-col items-center justify-center">
                                                                <div className="text-black flex items-center justify-center font-medium">
                                                                    {fichierCreation.name}
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <p className="text-base text-center font-semibold">
                                                                Cliquer pour charger le réçu de paiement
                                                            </p>
                                                        )}
                                                    </div>
                                                </button>
                                                {fichierCreation ? (
                                                    <button
                                                        disabled={loadingUpload}
                                                        className="mt-4 bg-main text-black text-sm font-semibold w-40 mx-auto h-8 rounded-lg flex items-center justify-center gap-x-1"
                                                        onClick={() => {
                                                            setLoadingUpload(true)
                                                            store(CHARGER_FICHIER, 'multipart/form-data', { reference: paiementRef, fichier: fichierCreation }).then((res) => {
                                                                setLoadingUpload(false);
                                                                if (res.status === 200) {
                                                                    setLoadingUpload(null);
                                                                    toast.success('Fichier chargé avec succès')
                                                                    setFichierCreation('')
                                                                }
                                                            }).catch((err) => {
                                                                setLoadingUpload(false);
                                                                if (err && err.response && err.response.data) {
                                                                    toast.error(err.response.data.donnee)
                                                                } else {
                                                                    toast.error("Une erreur s'est produite")
                                                                }
                                                            })
                                                        }}
                                                    >
                                                        {loadingUpload ? (
                                                            <span className="flex items-end justify-center gap-x-1">
                                                                Chargement{" "}
                                                                <span className="loading loading-dots loading-xs"></span>
                                                            </span>
                                                        ) : (
                                                            "Charger le fichier"
                                                        )}
                                                    </button>
                                                ) :
                                                    <ValidateMessage texte={'Paiement validé'} />
                                                }

                                                <input
                                                    id="file-zone"
                                                    type="file"
                                                    onChange={handleFileInput}
                                                    style={{ display: "none" }}
                                                />
                                            </div>
                                            <div className='text-center'>
                                            </div>
                                        </div>
                                        : <ValidateMessage texte={'Paiement validé'} />
                                ) : isFree?.isFree?.donnee ? <ValidateMessage texte={'Paiement validé'} /> : paiementChoix === 'MOMO' && (verify?.data?.donnee?.titre === "ATTENTE_DE_VALIDATION" || (verify?.data === null && verify?.loading)) && paiementRef != null ? (
                                    <div className=''>
                                        <img className='mx-auto rounded-full bg-gray-100 h-32 w-32' src={"https://img.freepik.com/vecteurs-premium/main-tenant-smartphone-ecran-vide-illustration-vectorielle-style-plat_576736-766.jpg?w=740"} alt="" />
                                        <p className='mx-auto font-light text-sm text-center'>
                                            Vous avez recu une demande de debit. <br />
                                            Tapez *133# puis choisissez l'option retrait pour approuver.
                                        </p>
                                    </div>
                                ) : paiementError ?
                                    <div>
                                        <p className='text-red-600 text-sm'>{paiementError}</p>
                                        <p className='text-red-600 text-sm'>{verify?.data?.donnee?.message !== "" ? 'Raison : ' + verify?.data?.donnee?.message : ""}</p>
                                        <button className='btn bg-main btn-sm' onClick={resetStates}>Réessayer</button>
                                    </div>
                                    :
                                    (
                                        <>
                                            <form onSubmit={handleSubmit(submit)} className="flex flex-col items-center justify-center w-full gap-x-3">
                                                <label className="form-control w-full">
                                                    <div className="label -mb-1">
                                                        <span className="label-text font-medium ">
                                                            Moyen de paiements <span className="text-red-500">*</span>
                                                        </span>
                                                    </div>
                                                    <select
                                                        {...register('modePaiement', { required: true })}
                                                        onChange={(e) => setPaiementChoix(e.target.value)}
                                                        className="select select-bordered w-full h-10 lg:max-w-xs "
                                                    >
                                                        {/* <option value="MOMO">MoMo</option> */}
                                                        <option value="CASH">Cash</option>
                                                    </select>
                                                </label>
                                                {paiementChoix === "MOMO" ? (
                                                    <>
                                                        <label className="form-control w-full">
                                                            <div className="label -mb-1">
                                                                <span className="label-text font-medium ">
                                                                    Numéro MoMo <span className="text-red-500">*</span>
                                                                </span>
                                                            </div>
                                                            <input
                                                                {...register('numeroMtn', { required: true })}
                                                                type="text"
                                                                placeholder="05*********** "
                                                                className="input input-bordered text-gray-500 w-full lg:max-w-xs h-10 text-sm font-semibold"
                                                            />
                                                        </label>
                                                    </>
                                                ) : (
                                                    <label className="form-control  w-full">
                                                        <div className="label -mb-1">
                                                            <span className="label-text font-medium text-gray-400">
                                                                Télécharger le reçu
                                                            </span>
                                                        </div>

                                                        <div className="max-w-xs">
                                                            <FilePond
                                                                files={filesRecuPaiement}
                                                                onupdatefiles={handleUpdateRecu}
                                                                allowImageResize="true"
                                                                acceptedFileTypes={["application/pdf"]}
                                                                allowMultiple={false}
                                                                labelIdle="Importer reçu de paiement"
                                                            />
                                                        </div>
                                                    </label>
                                                )}
                                                <div className='mr-auto w-full lg:w-96'>
                                                    <SubmitButton isSubmit={isSubmit} label={"faire le paiement"} />
                                                </div>
                                            </form>
                                        </>
                                    )
                            }
                        </>
                }

                <div className="w-full mt-4">
                    <hr />
                    <div
                        className="flex mt-4"
                        sx={{ display: "flex", flexDirection: "row", pt: 2 }}
                    >
                        <Box sx={{ flex: "1 1 auto" }} />
                        <span
                            disabled={loadingUpload === null && paiementChoix === 'MOMO' ? false : paiementRef !== null && paiementChoix === 'CASH' ? false : isFree?.isFree?.donnee ? false : true}
                            className={`bg-[#ffcb05] btn btn-sm py-1 px-2 font-medium rounded-lg `}
                            onClick={handleNext}
                        >
                            Poursuivre
                        </span>
                    </div>
                </div>
            </div >
        </>
    )
}
